import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "mx-4" }
const _hoisted_3 = { class: "mx-4" }

import UploadStatus from "@/components/CvrConvert/VehiclesListParts/UploadStatus.vue"
import UploadRequestPanel from "@/components/CvrConvert/UploadRequestPanel.vue"
import cvrUploadSummariesData from "@/types/responses/cvrUploadSummariesData"
import CvrUploadPeriod from "@/types/responses/getCvrUploadPeriod"
import getVehicleResponse from "@/types/responses/getVehicle"
import { Ref, ref, computed } from 'vue'
import Api from "@/services/api/ApiServiceFabrick"
import { ALL_DEVICE_TYPE } from "@/services/consts"
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'VehiclesRow',
  props: {
    item: {},
    reload: { type: Function },
    showFlash: { type: Function },
    vehicleWidth: {},
    acordionItemStyle: {},
    isDisplayCvrList: { type: Boolean },
    vehicle: {},
    searchWindowStatus: { type: Boolean },
    createAuthority: { type: Boolean }
  },
  emits: ['openCvrList'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props

const requestModalStatus: Ref<boolean> = ref(false)
const reading: Ref<boolean> = ref(false)
const selectedVehicle = ref({} as getVehicleResponse)
const ranges = ref<{start_at: Date, end_at: Date}[]>([])
const selectedVehicleId: Ref<number | null> = ref(null)

const groupNames = computed(() => {
  let names = ""
  props.item.group_names.forEach((name, index) => {
    if (index == 0) {
      names += name
    } else {
      names += `, ${name}`
    }
  })
  return names
})

const deviceModelType = computed(() => {
  return ALL_DEVICE_TYPE.filter((device: {type: string, id: number}) => {
    return device.id == props.item.device_model_type
  })[0].type
})

const openRequestModal = () => {
  requestModalStatus.value = true
  reading.value = true
  getVehicle(props.item.id)
}

const getVehicle = (id: number) => {
  Api().getAutoCompleteVehicle(id).then((response) => {
    selectedVehicle.value = response
    getCvrUploadPeriods(response.digital_tacograph)
  })
}

const getCvrUploadPeriods = (deviceId: number) => {
  Api().getCvrUploadPeriods(deviceId).then((res) => {
    reading.value = false;
    if (!res) return
    ranges.value = toDateRanges(res);
  })
}

const toDateRanges = (responses: CvrUploadPeriod[]) => {
  let periods = [] as { start_at: Date, end_at: Date }[];
  responses.forEach((response: { start_at: string, end_at: string }) => {
    const period = {
      start_at: new Date(response.start_at),
      end_at: new Date(response.end_at)
    } as { start_at: Date, end_at: Date }
    periods.push(period)
  })
  return periods;
}

const openCvrList = () => {
  if (props.searchWindowStatus) return
  selectedVehicleId.value = props.item.id
  emit('openCvrList', true, props.item)
}

const selectedVehicleBgColor = computed(() => {
  return props.isDisplayCvrList && props.item.id == props.vehicle.id ? 'background-color: #66cdaa' : ''
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", {
        id: String(props.item.id),
        class: _normalizeClass(props.vehicleWidth),
        style: _normalizeStyle(selectedVehicleBgColor.value)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(props.isDisplayCvrList ? '' : 'mx-4')
        }, _toDisplayString(props.item.number_plate), 3)
      ], 14, _hoisted_1),
      _createElementVNode("td", {
        style: _normalizeStyle(props.acordionItemStyle)
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(props.item.department_name), 1)
      ], 4),
      _createElementVNode("td", {
        style: _normalizeStyle(props.acordionItemStyle)
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(groupNames.value), 1)
      ], 4),
      _createElementVNode("td", {
        style: _normalizeStyle(props.acordionItemStyle),
        class: "text-center"
      }, _toDisplayString(deviceModelType.value), 5),
      _createElementVNode("td", {
        style: _normalizeStyle(props.acordionItemStyle),
        class: "text-center"
      }, _toDisplayString(props.item.count), 5),
      _createElementVNode("td", {
        style: _normalizeStyle(props.acordionItemStyle),
        class: "text-center"
      }, [
        _createVNode(_component_v_btn, { onClick: openCvrList }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.list.getVideoList')), 1)
          ]),
          _: 1
        })
      ], 4),
      _createVNode(UploadStatus, {
        item: props.item,
        acordionItemStyle: props.acordionItemStyle,
        openRequestModal: openRequestModal
      }, null, 8, ["item", "acordionItemStyle"])
    ]),
    _createVNode(UploadRequestPanel, {
      modelValue: requestModalStatus.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((requestModalStatus).value = $event)),
      reload: props.reload,
      showFlash: props.showFlash,
      reading: reading.value,
      ranges: ranges.value,
      selectedVehicle: selectedVehicle.value,
      createAuthority: props.createAuthority
    }, null, 8, ["modelValue", "reload", "showFlash", "reading", "ranges", "selectedVehicle", "createAuthority"])
  ], 64))
}
}

})